import MojitoPresentation from 'mojito/presentation';
import { range } from 'mojito/utils';
import EventCardSkeleton from './card/index.js';
import { memo } from 'react';

const { FlexPane } = MojitoPresentation.Components;

// eslint-disable-next-line react/display-name
const EventCardsSkeleton = memo(props => {
    const {
        mojitoTools: { config },
        elementRef,
    } = props;

    return (
        <FlexPane config={config.container} elementRef={elementRef}>
            {range(config.numberOfCards).map(i => (
                <EventCardSkeleton
                    key={i}
                    config={config.eventCardSkeleton}
                    elementRef={elementRef}
                />
            ))}
        </FlexPane>
    );
});

export default EventCardsSkeleton;
